import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any;
};

export enum AcademyCourseStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type Activity = Resource & {
  /** Unique identifier for this activity */
  activityId?: Maybe<Scalars['String']>;
  /** Whether the current user has bookmarked this resource */
  bookmarked: Scalars['Boolean'];
  /** The date this activity was completed */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** The timestamp of the resource creation */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** A description of the resource */
  description: Scalars['String'];
  /** The Academy team flagged this resource as featured */
  featured: Scalars['Boolean'];
  /** Whether the current user’s organization’s plan tier is sufficient to view this resource */
  gatedByPlan: Scalars['Boolean'];
  /** Unique identifier for this resource */
  id: Scalars['String'];
  /** The levels of the individual resource */
  levels: Array<ResourceLevel>;
  /** The topic of the resource */
  nonprofitTopic: Scalars['String'];
  /** The Academy team flagged this resource as popular */
  popular: Scalars['Boolean'];
  /** The tags of the individual resource */
  tags: Array<Scalars['String']>;
  /** The image URL for the resource’s thumbnail */
  thumbnailUrl: Scalars['String'];
  /** The title of the resource */
  title: Scalars['String'];
  /** The topics of the individual resource */
  topics: Array<Scalars['String']>;
  type: ResourceType;
  /** The date this activity was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ActivityStatus = {
  /** Unique identifier for this activity user has interacted with */
  activityId?: Maybe<Scalars['String']>;
  /** The date this activity was completed. Null if user manually uncheck checkbox */
  completedAt?: Maybe<Scalars['DateTime']>;
  /** The amount of time since the activity was completed */
  timeSinceCompletion?: Maybe<Scalars['String']>;
  /** The date this activity was last updated */
  updatedAt?: Maybe<Scalars['DateTime']>;
  /** Unique identifier for this user */
  userId?: Maybe<Scalars['Int']>;
};

export type AnalyticsProperties = {
  funderOrgId?: InputMaybe<Scalars['Int']>;
  nonprofitOrgId?: InputMaybe<Scalars['Int']>;
  platform?: InputMaybe<Scalars['String']>;
};

export type Article = Resource & {
  /** Whether the current user has bookmarked this resource */
  bookmarked: Scalars['Boolean'];
  /** The timestamp of the resource creation */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** A description of the resource */
  description: Scalars['String'];
  /** The Academy team flagged this resource as featured */
  featured: Scalars['Boolean'];
  /** Whether the current user’s organization’s plan tier is sufficient to view this resource */
  gatedByPlan: Scalars['Boolean'];
  /** Unique identifier for this resource */
  id: Scalars['String'];
  /** The levels of the individual resource */
  levels: Array<ResourceLevel>;
  /** The topic of the resource */
  nonprofitTopic: Scalars['String'];
  /** The Academy team flagged this resource as popular */
  popular: Scalars['Boolean'];
  /** The tags of the individual resource */
  tags: Array<Scalars['String']>;
  /** The image URL for the resource’s thumbnail */
  thumbnailUrl: Scalars['String'];
  /** The title of the resource */
  title: Scalars['String'];
  /** The topics of the individual resource */
  topics: Array<Scalars['String']>;
  type: ResourceType;
  /** The timestamp of the last update to the resource */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ContentSlide = Slide & {
  /** Nodes containing the elements that should be rendered as HTML, formatted as a JSON string of Contentful rich text */
  content: Scalars['String'];
  /** Unique identifier for the slide */
  id: Scalars['String'];
  /** The title of the content slide */
  title: Scalars['String'];
  type: SlideResourceType;
};

export type Course = Resource & {
  /** Whether the current user has bookmarked this resource */
  bookmarked: Scalars['Boolean'];
  /** The amount of minutes it would take to complete this course */
  completionTime?: Maybe<Scalars['Int']>;
  /** Unique identifier for this course. */
  courseId?: Maybe<Scalars['String']>;
  /** The timestamp of the resource creation */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** A description of the resource */
  description: Scalars['String'];
  /** The Academy team flagged this resource as featured */
  featured: Scalars['Boolean'];
  /** Whether the current user’s organization’s plan tier is sufficient to view this resource */
  gatedByPlan: Scalars['Boolean'];
  /** Unique identifier for this resource */
  id: Scalars['String'];
  /** The levels of the individual resource */
  levels: Array<ResourceLevel>;
  /** The topic of the resource */
  nonprofitTopic: Scalars['String'];
  /** The Academy team flagged this resource as popular */
  popular: Scalars['Boolean'];
  /** The current user’s completion status for this course */
  status?: Maybe<ResourceStatus>;
  /** The tags of the individual resource */
  tags: Array<Scalars['String']>;
  /** The image URL for the resource’s thumbnail */
  thumbnailUrl: Scalars['String'];
  /** The title of the resource */
  title: Scalars['String'];
  /** The topics of the individual resource */
  topics: Array<Scalars['String']>;
  type: ResourceType;
  /** The timestamp of the last update to the resource */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type CourseContent = {
  /** Unique identifier for this course */
  courseId: Scalars['String'];
  /** Course description */
  preview: Scalars['String'];
  /** Unique identifier of the resource that contains the course */
  resourceId: Scalars['String'];
  slides: Array<Slide>;
  /** Course title */
  title: Scalars['String'];
};

export type CourseProgress = {
  courseId?: Maybe<Scalars['String']>;
  currentSlideId?: Maybe<Scalars['String']>;
  status?: Maybe<AcademyCourseStatus>;
  topicId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['Int']>;
};

export enum CourseStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS'
}

export type DownloadableAsset = {
  /** Content type of the asset */
  contentType: Scalars['String'];
  /** File name of the asset */
  fileName: Scalars['String'];
  /** ID of the asset */
  id: Scalars['String'];
  /** URL of the asset */
  url: Scalars['String'];
};

export type EmbeddedAsset = {
  /** The content type of the asset */
  contentType: Scalars['String'];
  /** The description of the asset */
  description: Scalars['String'];
  /** The fileName of the asset */
  fileName: Scalars['String'];
  /** Unique identifier for the asset */
  id: Scalars['String'];
  /** The URL of the asset */
  url: Scalars['String'];
};

export type FunderReportResourceInteraction = {
  /** The topic related to the nonprofit sector of the resource. */
  nonprofitTopic: Scalars['String'];
  /** The unique contentful identifier for the resource. */
  resourceId: Scalars['String'];
  /** The type of resource (article, course, template). */
  resourceType: Scalars['String'];
  /** The current user’s completion status of the resource */
  status?: Maybe<Array<Maybe<ResourceStatus>>>;
  /** The title of the resource. */
  title: Scalars['String'];
};

export type FunderReportResponseType = {
  /** A list of resources (id, type, interaction type, topic) that have been interacted with an array of users */
  interactions: Array<FunderReportResourceInteraction>;
};

export type ImpactDashboardActivity = {
  resource: ImpactDashboardActivityResourceDetails;
  userId: Scalars['Int'];
  userStatus: Scalars['String'];
};

export type ImpactDashboardActivityResourceDetails = {
  courseId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  nonprofitTopic: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type ImpactReportResourceNode = {
  /** The unique identifier for the resource. */
  id: Scalars['String'];
  /** The topic related to the nonprofit sector of the resource. */
  nonprofitTopic: Scalars['String'];
};

export type ImpactReportResponseType = {
  /** A list of nonprofit topics and resource ids relevant to the impact report. */
  nodes: Array<ImpactReportResourceNode>;
};

export type LearningTrack = {
  /** Whether the current user has bookmarked this learning track */
  bookmarked: Scalars['Boolean'];
  /** The description of the learning track */
  description: Scalars['String'];
  /** Whether the learning track is gated by read permissions */
  gatedByPlan: Scalars['Boolean'];
  /** Unique identifier for this learning track */
  id: Scalars['String'];
  modules: Array<Module>;
  /** The percentage of the learning track completed by the user */
  percentageCompleted: Scalars['Int'];
  /** The recommended persona for the learning track */
  recommendedFor: Array<Scalars['String']>;
  /** The skills (resource tags) acquired during the learning track */
  skills: Array<Scalars['String']>;
  /** The current user’s completion status of the learning track */
  status?: Maybe<ResourceStatus>;
  /** The image URL for the learning track’s thumbnail */
  thumbnailUrl: Scalars['String'];
  /** The title of the learning track */
  title: Scalars['String'];
  trackType: LearningTrackType;
};

export enum LearningTrackType {
  Professional = 'Professional',
  Topical = 'Topical'
}

export type Module = {
  /** The description of the module */
  description: Scalars['String'];
  /** The fields of focus of the learning track */
  focusOn: Array<Scalars['String']>;
  forACloserLook: Array<ModuleContent>;
  /** Unique identifier for this module */
  id: Scalars['String'];
  learn: Array<ModuleContent>;
  takeAction: Array<ModuleContent>;
  /** The title of the module */
  title: Scalars['String'];
};

export type ModuleContent = {
  /** Whether the current user has bookmarked this content */
  bookmarked: Scalars['Boolean'];
  /** Unique identifier for content type course */
  courseId: Scalars['String'];
  /** The description of the content */
  description: Scalars['String'];
  /** Whether the current user’s organization’s plan tier is sufficient to view this resource */
  gatedByPlan: Scalars['Boolean'];
  /** Unique identifier for this content */
  id: Scalars['String'];
  /** The current user’s completion status of the resource */
  status?: Maybe<ResourceStatus>;
  /** The tags of the individual resource */
  tags: Array<Scalars['String']>;
  thumbnail?: Maybe<ModuleThumbnail>;
  /** The title of the resource */
  title: Scalars['String'];
  /** The resource type included in the learning section */
  type: ResourceType;
  /** A link to the URL of the content */
  url: Scalars['String'];
};

export type ModuleThumbnail = {
  /** The description of the thumbnail */
  description?: Maybe<Scalars['String']>;
  /** Unique identifier for the thumbnail */
  id?: Maybe<Scalars['String']>;
  /** The title of the thumbnail */
  title?: Maybe<Scalars['String']>;
  /** The URL of the thumbnail */
  url?: Maybe<Scalars['String']>;
};

export type Mutation = {
  removeSavedAcademyResourceForUser?: Maybe<UserToSavedAcademyResource>;
  saveAcademyResourceForUser?: Maybe<UserToSavedAcademyResource>;
  setCourseProgress?: Maybe<SetCourseProgressResponse>;
  trackBulkResourceAction?: Maybe<TrackBulkResourceActionResponse>;
  trackResourceAction?: Maybe<TrackResourceActionResponse>;
  upsertActivityStatus?: Maybe<ActivityStatus>;
  upsertCourseProgress?: Maybe<CourseProgress>;
};


export type MutationRemoveSavedAcademyResourceForUserArgs = {
  academyResourceId: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationSaveAcademyResourceForUserArgs = {
  academyResourceId: Scalars['String'];
  userId: Scalars['Int'];
};


export type MutationSetCourseProgressArgs = {
  analyticsProperties: AnalyticsProperties;
  courseId: Scalars['String'];
  resourceId: Scalars['String'];
  slideId: Scalars['String'];
  topicId: Scalars['String'];
};


export type MutationTrackBulkResourceActionArgs = {
  actions: Array<TrackBulkResourceActionInput>;
};


export type MutationTrackResourceActionArgs = {
  action: ResourceAction;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  resourceId: Scalars['String'];
  userId?: InputMaybe<Scalars['Int']>;
};


export type MutationUpsertActivityStatusArgs = {
  activityId: Scalars['String'];
  checked: Scalars['Boolean'];
};


export type MutationUpsertCourseProgressArgs = {
  courseId: Scalars['String'];
  currentSlideId: Scalars['String'];
  status: AcademyCourseStatus;
  topicId: Scalars['String'];
  userId: Scalars['Int'];
};

export type PartialLearningTrackResource = Resource & {
  /** Whether the current user has bookmarked this resource */
  bookmarked: Scalars['Boolean'];
  /** The timestamp of the resource creation */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** A description of the resource */
  description: Scalars['String'];
  /** The Academy team flagged this resource as featured */
  featured: Scalars['Boolean'];
  /** Whether the current user’s organization’s plan tier is sufficient to view this resource */
  gatedByPlan: Scalars['Boolean'];
  /** Unique identifier for this resource */
  id: Scalars['String'];
  /** The levels of the individual resource */
  levels: Array<ResourceLevel>;
  /** The topic of the resource */
  nonprofitTopic: Scalars['String'];
  /** The Academy team flagged this resource as popular */
  popular: Scalars['Boolean'];
  /** The current user’s completion status of the learning track */
  status?: Maybe<ResourceStatus>;
  /** The tags of the individual resource */
  tags: Array<Scalars['String']>;
  /** The image URL for the resource’s thumbnail */
  thumbnailUrl: Scalars['String'];
  /** The title of the resource */
  title: Scalars['String'];
  /** The topics of the individual resource */
  topics: Array<Scalars['String']>;
  type: ResourceType;
  /** The timestamp of the last update to the resource */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type Query = {
  UserToSavedAcademyResource?: Maybe<Array<Maybe<UserToSavedAcademyResource>>>;
  courseContent: CourseContent;
  courseProgress?: Maybe<CourseProgress>;
  getActivityStatuses?: Maybe<Array<Maybe<ActivityStatus>>>;
  impactDashboardAcademyActivity: Array<ImpactDashboardActivity>;
  learningTrack?: Maybe<LearningTrack>;
  resource?: Maybe<SingleResource>;
  resourceInteractionsForFunderReport?: Maybe<FunderReportResponseType>;
  resources?: Maybe<ResourcesResponse>;
  resourcesForImpactReport?: Maybe<ImpactReportResponseType>;
};


export type QueryUserToSavedAcademyResourceArgs = {
  userId: Scalars['Int'];
};


export type QueryCourseContentArgs = {
  resourceId: Scalars['String'];
};


export type QueryCourseProgressArgs = {
  courseId: Scalars['String'];
  topicId?: InputMaybe<Scalars['String']>;
  userId: Scalars['Int'];
};


export type QueryImpactDashboardAcademyActivityArgs = {
  userIds: Array<Scalars['Int']>;
};


export type QueryLearningTrackArgs = {
  id: Scalars['String'];
};


export type QueryResourceArgs = {
  courseId?: InputMaybe<Scalars['String']>;
  resourceId?: InputMaybe<Scalars['String']>;
};


export type QueryResourceInteractionsForFunderReportArgs = {
  end?: InputMaybe<Scalars['DateTime']>;
  start?: InputMaybe<Scalars['DateTime']>;
  userIds: Array<Scalars['Int']>;
};


export type QueryResourcesArgs = {
  anonymousId?: InputMaybe<Scalars['String']>;
  bookmarked?: InputMaybe<Scalars['Boolean']>;
  createdAtGte?: InputMaybe<Scalars['DateTime']>;
  createdAtLte?: InputMaybe<Scalars['DateTime']>;
  featured?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['String']>>;
  idsToExclude?: InputMaybe<Array<Scalars['String']>>;
  levels?: InputMaybe<Array<ResourceLevel>>;
  limit?: InputMaybe<Scalars['Int']>;
  popular?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  resourceType?: InputMaybe<Array<ResourceType>>;
  sort?: InputMaybe<ResourceSortOptions>;
  status?: InputMaybe<Array<ResourceStatus>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
  topics?: InputMaybe<Array<Scalars['String']>>;
  updatedAtGte?: InputMaybe<Scalars['DateTime']>;
  updatedAtLte?: InputMaybe<Scalars['DateTime']>;
};


export type QueryResourcesForImpactReportArgs = {
  ids: Array<Scalars['String']>;
};

export type Resource = {
  /** Whether the current user has bookmarked this resource */
  bookmarked: Scalars['Boolean'];
  /** The timestamp of the resource creation */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** A description of the resource */
  description: Scalars['String'];
  /** The Academy team flagged this resource as featured */
  featured: Scalars['Boolean'];
  /** Whether the current user’s organization’s plan tier is sufficient to view this resource */
  gatedByPlan: Scalars['Boolean'];
  /** Unique identifier for this resource */
  id: Scalars['String'];
  /** The levels of the individual resource */
  levels: Array<ResourceLevel>;
  /** The topic of the resource */
  nonprofitTopic: Scalars['String'];
  /** The Academy team flagged this resource as popular */
  popular: Scalars['Boolean'];
  /** The tags of the individual resource */
  tags: Array<Scalars['String']>;
  /** The image URL for the resource’s thumbnail */
  thumbnailUrl: Scalars['String'];
  /** The title of the resource */
  title: Scalars['String'];
  /** The topics of the individual resource */
  topics: Array<Scalars['String']>;
  type: ResourceType;
  /** The timestamp of the last update to the resource */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum ResourceAction {
  Downloaded = 'DOWNLOADED',
  Viewed = 'VIEWED'
}

export type ResourceCta = {
  /** The ID of the AppCta object in Contentful */
  id: Scalars['String'];
  /** The title of the CTA */
  title: Scalars['String'];
  /** The URL the CTA should link to. Can be absolute or relative. */
  url: Scalars['String'];
};

export enum ResourceLevel {
  Early = 'early',
  Late = 'late',
  Mid = 'mid'
}

export enum ResourceSortOptions {
  Alphabetical = 'alphabetical',
  CreatedAtAsc = 'createdAtAsc',
  CreatedAtDesc = 'createdAtDesc',
  Random = 'random',
  Relevance = 'relevance',
  UpdatedAtAsc = 'updatedAtAsc',
  UpdatedAtDesc = 'updatedAtDesc'
}

export enum ResourceStatus {
  Completed = 'completed',
  Downloaded = 'downloaded',
  InProgress = 'in_progress',
  Viewed = 'viewed'
}

export enum ResourceType {
  Activity = 'activity',
  Article = 'article',
  Course = 'course',
  LearningTrack = 'learning_track',
  Template = 'template'
}

export type ResourcesResponse = {
  nodes?: Maybe<Array<Maybe<Resource>>>;
  totalCount?: Maybe<Scalars['Int']>;
};

export type SetCourseProgressResponse = {
  status: Scalars['String'];
};

export type SingleArticleResource = SingleResourceContent & {
  /** Nodes representing the article content, it contains the elements that should be rendered as HTML, formatted as a JSON string of Contentful rich text */
  content: Scalars['String'];
  /** Nodes representing the article's call to action */
  ctas: Array<ResourceCta>;
  /** A list of assets that are linked in the `content` rich text */
  embeddedAssets: Array<EmbeddedAsset>;
  /** The header for the description */
  header: Scalars['String'];
  /** The description for the resource */
  metaDescription: Scalars['String'];
  /** The related content tags to the resource */
  tags: Array<Scalars['String']>;
  thumbnail?: Maybe<ModuleThumbnail>;
  /** The title of the article */
  title: Scalars['String'];
  type: SingleResourceType;
};

export type SingleCourseProgress = {
  /** Unique identifier for last slide seen */
  currentSlideId?: Maybe<Scalars['String']>;
  /** The current user's completion status for this course */
  status?: Maybe<CourseStatus>;
};

export type SingleCourseResource = SingleResourceContent & {
  /** The amount of minutes it would take to complete this course */
  completionTime?: Maybe<Scalars['Int']>;
  /** Unique identifier for this course */
  courseId: Scalars['String'];
  /** Nodes representing the article's call to action */
  ctas: Array<ResourceCta>;
  /** A list of assets that are linked in the `content` rich text of any Content slides */
  embeddedAssets: Array<EmbeddedAsset>;
  /** Course description */
  preview: Scalars['String'];
  progress?: Maybe<SingleCourseProgress>;
  slides: Array<Slide>;
  /** The related content tags to the resource */
  tags: Array<Scalars['String']>;
  thumbnail?: Maybe<ModuleThumbnail>;
  /** Course title */
  title: Scalars['String'];
  type: SingleResourceType;
};

export type SingleResource = {
  /** Boolean representation of the resource bookmarked status */
  isBookmarked: Scalars['Boolean'];
  /** Unique identifier for this resource */
  resourceId: Scalars['String'];
  singleResourceContent: SingleResourceContent;
};

export type SingleResourceContent = {
  /** Nodes representing the article's call to action */
  ctas: Array<ResourceCta>;
  /** The related content tags to the resource */
  tags: Array<Scalars['String']>;
  thumbnail?: Maybe<ModuleThumbnail>;
  type: SingleResourceType;
};

export enum SingleResourceType {
  Article = 'article',
  Course = 'course',
  Template = 'template'
}

export type SingleTemplateResource = SingleResourceContent & {
  /** Nodes containing the elements that should be rendered as HTML, formatted as a JSON string of Contentful rich text */
  content: Scalars['String'];
  /** Nodes representing the article's call to action */
  ctas: Array<ResourceCta>;
  /** The description of the Article */
  description: Scalars['String'];
  /** The title description of the Article */
  descriptionTitle: Scalars['String'];
  /** A link to the downloadable version of this template */
  downloadableAsset?: Maybe<DownloadableAsset>;
  /** A list of assets that are linked in the `content` rich text */
  embeddedAssets: Array<EmbeddedAsset>;
  /** The name of the template file */
  fileName: Scalars['String'];
  /** The header for the description */
  header: Scalars['String'];
  /** The short-text meta description for the resource */
  metaDescription: Scalars['String'];
  /** The related content tags to the resource */
  tags: Array<Scalars['String']>;
  /** The ID of the template */
  templateId: Scalars['String'];
  thumbnail?: Maybe<ModuleThumbnail>;
  /** The title of the template */
  title: Scalars['String'];
  type: SingleResourceType;
  typeform?: Maybe<TemplateTypeform>;
};

export type Slide = {
  /** Unique identifier for the slide */
  id: Scalars['String'];
  type: SlideResourceType;
};

export enum SlideResourceType {
  Content = 'content',
  Typeform = 'typeform',
  Video = 'video'
}

export type Template = Resource & {
  /** Whether the current user has bookmarked this resource */
  bookmarked: Scalars['Boolean'];
  /** The timestamp of the resource creation */
  createdAt?: Maybe<Scalars['DateTime']>;
  /** A description of the resource */
  description: Scalars['String'];
  /** The Academy team flagged this resource as featured */
  featured: Scalars['Boolean'];
  /** Whether the current user’s organization’s plan tier is sufficient to view this resource */
  gatedByPlan: Scalars['Boolean'];
  /** Unique identifier for this resource */
  id: Scalars['String'];
  /** The levels of the individual resource */
  levels: Array<ResourceLevel>;
  /** The topic of the resource */
  nonprofitTopic: Scalars['String'];
  /** The Academy team flagged this resource as popular */
  popular: Scalars['Boolean'];
  /** The tags of the individual resource */
  tags: Array<Scalars['String']>;
  /** The image URL for the resource’s thumbnail */
  thumbnailUrl: Scalars['String'];
  /** The title of the resource */
  title: Scalars['String'];
  /** The topics of the individual resource */
  topics: Array<Scalars['String']>;
  type: ResourceType;
  /** The timestamp of the last update to the resource */
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type TemplateTypeform = {
  /** The ID extracted of the Typeform URL */
  typeformId: Scalars['String'];
  /** The URL of the Typeform */
  typeformUrl: Scalars['String'];
};

export type TrackBulkResourceActionInput = {
  /** Action type being tracked */
  action: ResourceAction;
  /** Timestamp of the action occurrence. Defaults to now. */
  createdAt: Scalars['DateTime'];
  /** Contentful ID for the resource interacted with */
  resourceId: Scalars['String'];
  /** ID of the user making the action */
  userId: Scalars['Int'];
};

export type TrackBulkResourceActionResponse = {
  /** Number of actions successfully tracked */
  count?: Maybe<Scalars['Int']>;
};

export type TrackResourceActionResponse = {
  /** The action performed */
  action: ResourceAction;
  /** The timestamp of this action instance */
  createdAt: Scalars['DateTime'];
  /** The ID of this action instance */
  id: Scalars['Int'];
  /** The Contentful ID of the resource acted on */
  resourceId: Scalars['String'];
  /** The ID of the user who performed the action */
  userId: Scalars['Int'];
};

export type TypeformSlide = Slide & {
  /** Unique identifier for the slide */
  id: Scalars['String'];
  /** The title of the Typeform slide */
  title: Scalars['String'];
  type: SlideResourceType;
  /** The ID extracted of the Typeform URL */
  typeformId: Scalars['String'];
  /** The URL of the Typeform */
  typeformUrl: Scalars['String'];
};

export type UserToSavedAcademyResource = {
  academyResourceId: Scalars['String'];
  userId: Scalars['Int'];
};

export type VideoDetails = {
  /** Unique identifier for the video */
  id: Scalars['ID'];
  /** Corresponding Wistia ID to the video */
  wistiaId: Scalars['String'];
};

export type VideoSlide = Slide & {
  /** Unique identifier for the slide */
  id: Scalars['String'];
  /** The title of the video slide */
  title: Scalars['String'];
  type: SlideResourceType;
  /** The HTML content of the video slide formatted as a JSON string of Contentful rich text */
  videoContent: Scalars['String'];
  videoDetails: VideoDetails;
};

export type RemoveSavedAcademyResourceForUserMutationVariables = Exact<{
  academyResourceId: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type RemoveSavedAcademyResourceForUserMutation = { removeSavedAcademyResourceForUser?: { academyResourceId: string, userId: number } | null };

export type SaveAcademyResourceForUserMutationVariables = Exact<{
  academyResourceId: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type SaveAcademyResourceForUserMutation = { saveAcademyResourceForUser?: { academyResourceId: string, userId: number } | null };

export type SetCourseProgressMutationVariables = Exact<{
  resourceId: Scalars['String'];
  courseId: Scalars['String'];
  topicId: Scalars['String'];
  slideId: Scalars['String'];
  analyticsProperties: AnalyticsProperties;
}>;


export type SetCourseProgressMutation = { setCourseProgress?: { status: string } | null };

export type TrackResourceActionMutationVariables = Exact<{
  action: ResourceAction;
  resourceId: Scalars['String'];
}>;


export type TrackResourceActionMutation = { trackResourceAction?: { id: number } | null };

export type UpsertActivityStatusMutationVariables = Exact<{
  activityId: Scalars['String'];
  checked: Scalars['Boolean'];
}>;


export type UpsertActivityStatusMutation = { upsertActivityStatus?: { activityId?: string | null, completedAt?: any | null } | null };

export type UpsertCourseProgressMutationVariables = Exact<{
  topicId: Scalars['String'];
  courseId: Scalars['String'];
  currentSlideId: Scalars['String'];
  status: AcademyCourseStatus;
  userId: Scalars['Int'];
}>;


export type UpsertCourseProgressMutation = { upsertCourseProgress?: { userId?: number | null, topicId?: string | null, courseId?: string | null, currentSlideId?: string | null, status?: AcademyCourseStatus | null } | null };

export type ResourceQueryVariables = Exact<{
  resourceId?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['String']>;
}>;


export type ResourceQuery = { resource?: { resourceId: string, isBookmarked: boolean, singleResourceContent: { title: string, metaDescription: string, tags: Array<string>, header: string, content: string, type: SingleResourceType, embeddedAssets: Array<{ id: string, contentType: string, fileName: string, description: string, url: string }>, thumbnail?: { id?: string | null, title?: string | null, description?: string | null, url?: string | null } | null, ctas: Array<{ id: string, title: string, url: string }> } | { courseId: string, title: string, preview: string, completionTime?: number | null, tags: Array<string>, type: SingleResourceType, embeddedAssets: Array<{ id: string, fileName: string, description: string, url: string, contentType: string }>, progress?: { status?: CourseStatus | null, currentSlideId?: string | null } | null, thumbnail?: { id?: string | null, description?: string | null, title?: string | null, url?: string | null } | null, ctas: Array<{ id: string, title: string, url: string }>, slides: Array<{ title: string, content: string, id: string, type: SlideResourceType } | { title: string, typeformId: string, typeformUrl: string, id: string, type: SlideResourceType } | { title: string, videoContent: string, id: string, type: SlideResourceType, videoDetails: { id: string, wistiaId: string } }> } | { templateId: string, title: string, metaDescription: string, tags: Array<string>, header: string, descriptionTitle: string, description: string, fileName: string, content: string, type: SingleResourceType, typeform?: { typeformId: string, typeformUrl: string } | null, ctas: Array<{ id: string, title: string, url: string }>, thumbnail?: { id?: string | null, title?: string | null, description?: string | null, url?: string | null } | null, embeddedAssets: Array<{ id: string, contentType: string, fileName: string, description: string, url: string }>, downloadableAsset?: { id: string, fileName: string, contentType: string, url: string } | null } } | null };

export type ResourcesQueryVariables = Exact<{
  featured?: InputMaybe<Scalars['Boolean']>;
  limit?: InputMaybe<Scalars['Int']>;
  popular?: InputMaybe<Scalars['Boolean']>;
  query?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<ResourceSortOptions>;
  resourceType?: InputMaybe<Array<ResourceType> | ResourceType>;
  bookmarked?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Array<ResourceStatus> | ResourceStatus>;
  ids?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  tags?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  idsToExclude?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  anonymousId?: InputMaybe<Scalars['String']>;
  createdAtGte?: InputMaybe<Scalars['DateTime']>;
  updatedAtGte?: InputMaybe<Scalars['DateTime']>;
  topics?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  levels?: InputMaybe<Array<ResourceLevel> | ResourceLevel>;
}>;


export type ResourcesQuery = { resources?: { totalCount?: number | null, nodes?: Array<{ bookmarked: boolean, description: string, featured: boolean, gatedByPlan: boolean, id: string, nonprofitTopic: string, popular: boolean, thumbnailUrl: string, tags: Array<string>, topics: Array<string>, levels: Array<ResourceLevel>, title: string, type: ResourceType, createdAt?: any | null, updatedAt?: any | null } | { bookmarked: boolean, description: string, featured: boolean, gatedByPlan: boolean, id: string, nonprofitTopic: string, popular: boolean, thumbnailUrl: string, tags: Array<string>, topics: Array<string>, levels: Array<ResourceLevel>, title: string, type: ResourceType, createdAt?: any | null, updatedAt?: any | null } | { completionTime?: number | null, courseId?: string | null, status?: ResourceStatus | null, bookmarked: boolean, description: string, featured: boolean, gatedByPlan: boolean, id: string, nonprofitTopic: string, popular: boolean, thumbnailUrl: string, tags: Array<string>, topics: Array<string>, levels: Array<ResourceLevel>, title: string, type: ResourceType, createdAt?: any | null, updatedAt?: any | null } | { status?: ResourceStatus | null, bookmarked: boolean, description: string, featured: boolean, gatedByPlan: boolean, id: string, nonprofitTopic: string, popular: boolean, thumbnailUrl: string, tags: Array<string>, topics: Array<string>, levels: Array<ResourceLevel>, title: string, type: ResourceType, createdAt?: any | null, updatedAt?: any | null } | { bookmarked: boolean, description: string, featured: boolean, gatedByPlan: boolean, id: string, nonprofitTopic: string, popular: boolean, thumbnailUrl: string, tags: Array<string>, topics: Array<string>, levels: Array<ResourceLevel>, title: string, type: ResourceType, createdAt?: any | null, updatedAt?: any | null } | null> | null } | null };

export type GetActivityStatusesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActivityStatusesQuery = { getActivityStatuses?: Array<{ activityId?: string | null, completedAt?: any | null, timeSinceCompletion?: string | null } | null> | null };

export type CourseContentQueryVariables = Exact<{
  resourceId: Scalars['String'];
}>;


export type CourseContentQuery = { courseContent: { courseId: string, resourceId: string, title: string, preview: string, slides: Array<{ title: string, content: string, id: string, type: SlideResourceType } | { title: string, typeformUrl: string, typeformId: string, id: string, type: SlideResourceType } | { title: string, videoContent: string, id: string, type: SlideResourceType, videoDetails: { id: string, wistiaId: string } }> } };

export type CourseProgressQueryVariables = Exact<{
  topicId?: InputMaybe<Scalars['String']>;
  courseId: Scalars['String'];
  userId: Scalars['Int'];
}>;


export type CourseProgressQuery = { courseProgress?: { courseId?: string | null, topicId?: string | null, userId?: number | null, currentSlideId?: string | null, status?: AcademyCourseStatus | null } | null };

export type LearningTrackQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type LearningTrackQuery = { learningTrack?: { bookmarked: boolean, id: string, title: string, description: string, gatedByPlan: boolean, trackType: LearningTrackType, recommendedFor: Array<string>, percentageCompleted: number, thumbnailUrl: string, skills: Array<string>, status?: ResourceStatus | null, modules: Array<{ id: string, title: string, description: string, focusOn: Array<string>, learn: Array<{ bookmarked: boolean, id: string, gatedByPlan: boolean, type: ResourceType, title: string, description: string, status?: ResourceStatus | null, tags: Array<string>, url: string, thumbnail?: { id?: string | null, title?: string | null, description?: string | null, url?: string | null } | null }>, takeAction: Array<{ bookmarked: boolean, id: string, gatedByPlan: boolean, type: ResourceType, title: string, description: string, status?: ResourceStatus | null, tags: Array<string>, url: string, thumbnail?: { id?: string | null, title?: string | null, description?: string | null, url?: string | null } | null }>, forACloserLook: Array<{ bookmarked: boolean, courseId: string, id: string, gatedByPlan: boolean, type: ResourceType, title: string, description: string, status?: ResourceStatus | null, tags: Array<string>, url: string, thumbnail?: { id?: string | null, title?: string | null, description?: string | null, url?: string | null } | null }> }> } | null };

export type UserToSavedAcademyResourceQueryVariables = Exact<{
  userId: Scalars['Int'];
}>;


export type UserToSavedAcademyResourceQuery = { UserToSavedAcademyResource?: Array<{ userId: number, academyResourceId: string } | null> | null };


export const RemoveSavedAcademyResourceForUserDocument = gql`
    mutation removeSavedAcademyResourceForUser($academyResourceId: String!, $userId: Int!) {
  removeSavedAcademyResourceForUser(
    academyResourceId: $academyResourceId
    userId: $userId
  ) {
    academyResourceId
    userId
  }
}
    `;
export type RemoveSavedAcademyResourceForUserMutationFn = Apollo.MutationFunction<RemoveSavedAcademyResourceForUserMutation, RemoveSavedAcademyResourceForUserMutationVariables>;

/**
 * __useRemoveSavedAcademyResourceForUserMutation__
 *
 * To run a mutation, you first call `useRemoveSavedAcademyResourceForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveSavedAcademyResourceForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeSavedAcademyResourceForUserMutation, { data, loading, error }] = useRemoveSavedAcademyResourceForUserMutation({
 *   variables: {
 *      academyResourceId: // value for 'academyResourceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveSavedAcademyResourceForUserMutation(baseOptions?: Apollo.MutationHookOptions<RemoveSavedAcademyResourceForUserMutation, RemoveSavedAcademyResourceForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveSavedAcademyResourceForUserMutation, RemoveSavedAcademyResourceForUserMutationVariables>(RemoveSavedAcademyResourceForUserDocument, options);
      }
export type RemoveSavedAcademyResourceForUserMutationHookResult = ReturnType<typeof useRemoveSavedAcademyResourceForUserMutation>;
export type RemoveSavedAcademyResourceForUserMutationResult = Apollo.MutationResult<RemoveSavedAcademyResourceForUserMutation>;
export type RemoveSavedAcademyResourceForUserMutationOptions = Apollo.BaseMutationOptions<RemoveSavedAcademyResourceForUserMutation, RemoveSavedAcademyResourceForUserMutationVariables>;
export const SaveAcademyResourceForUserDocument = gql`
    mutation saveAcademyResourceForUser($academyResourceId: String!, $userId: Int!) {
  saveAcademyResourceForUser(
    academyResourceId: $academyResourceId
    userId: $userId
  ) {
    academyResourceId
    userId
  }
}
    `;
export type SaveAcademyResourceForUserMutationFn = Apollo.MutationFunction<SaveAcademyResourceForUserMutation, SaveAcademyResourceForUserMutationVariables>;

/**
 * __useSaveAcademyResourceForUserMutation__
 *
 * To run a mutation, you first call `useSaveAcademyResourceForUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveAcademyResourceForUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveAcademyResourceForUserMutation, { data, loading, error }] = useSaveAcademyResourceForUserMutation({
 *   variables: {
 *      academyResourceId: // value for 'academyResourceId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useSaveAcademyResourceForUserMutation(baseOptions?: Apollo.MutationHookOptions<SaveAcademyResourceForUserMutation, SaveAcademyResourceForUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveAcademyResourceForUserMutation, SaveAcademyResourceForUserMutationVariables>(SaveAcademyResourceForUserDocument, options);
      }
export type SaveAcademyResourceForUserMutationHookResult = ReturnType<typeof useSaveAcademyResourceForUserMutation>;
export type SaveAcademyResourceForUserMutationResult = Apollo.MutationResult<SaveAcademyResourceForUserMutation>;
export type SaveAcademyResourceForUserMutationOptions = Apollo.BaseMutationOptions<SaveAcademyResourceForUserMutation, SaveAcademyResourceForUserMutationVariables>;
export const SetCourseProgressDocument = gql`
    mutation SetCourseProgress($resourceId: String!, $courseId: String!, $topicId: String!, $slideId: String!, $analyticsProperties: AnalyticsProperties!) {
  setCourseProgress(
    resourceId: $resourceId
    courseId: $courseId
    topicId: $topicId
    slideId: $slideId
    analyticsProperties: $analyticsProperties
  ) {
    status
  }
}
    `;
export type SetCourseProgressMutationFn = Apollo.MutationFunction<SetCourseProgressMutation, SetCourseProgressMutationVariables>;

/**
 * __useSetCourseProgressMutation__
 *
 * To run a mutation, you first call `useSetCourseProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCourseProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCourseProgressMutation, { data, loading, error }] = useSetCourseProgressMutation({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      courseId: // value for 'courseId'
 *      topicId: // value for 'topicId'
 *      slideId: // value for 'slideId'
 *      analyticsProperties: // value for 'analyticsProperties'
 *   },
 * });
 */
export function useSetCourseProgressMutation(baseOptions?: Apollo.MutationHookOptions<SetCourseProgressMutation, SetCourseProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCourseProgressMutation, SetCourseProgressMutationVariables>(SetCourseProgressDocument, options);
      }
export type SetCourseProgressMutationHookResult = ReturnType<typeof useSetCourseProgressMutation>;
export type SetCourseProgressMutationResult = Apollo.MutationResult<SetCourseProgressMutation>;
export type SetCourseProgressMutationOptions = Apollo.BaseMutationOptions<SetCourseProgressMutation, SetCourseProgressMutationVariables>;
export const TrackResourceActionDocument = gql`
    mutation TrackResourceAction($action: ResourceAction!, $resourceId: String!) {
  trackResourceAction(action: $action, resourceId: $resourceId) {
    id
  }
}
    `;
export type TrackResourceActionMutationFn = Apollo.MutationFunction<TrackResourceActionMutation, TrackResourceActionMutationVariables>;

/**
 * __useTrackResourceActionMutation__
 *
 * To run a mutation, you first call `useTrackResourceActionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrackResourceActionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trackResourceActionMutation, { data, loading, error }] = useTrackResourceActionMutation({
 *   variables: {
 *      action: // value for 'action'
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useTrackResourceActionMutation(baseOptions?: Apollo.MutationHookOptions<TrackResourceActionMutation, TrackResourceActionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrackResourceActionMutation, TrackResourceActionMutationVariables>(TrackResourceActionDocument, options);
      }
export type TrackResourceActionMutationHookResult = ReturnType<typeof useTrackResourceActionMutation>;
export type TrackResourceActionMutationResult = Apollo.MutationResult<TrackResourceActionMutation>;
export type TrackResourceActionMutationOptions = Apollo.BaseMutationOptions<TrackResourceActionMutation, TrackResourceActionMutationVariables>;
export const UpsertActivityStatusDocument = gql`
    mutation upsertActivityStatus($activityId: String!, $checked: Boolean!) {
  upsertActivityStatus(activityId: $activityId, checked: $checked) {
    activityId
    completedAt
  }
}
    `;
export type UpsertActivityStatusMutationFn = Apollo.MutationFunction<UpsertActivityStatusMutation, UpsertActivityStatusMutationVariables>;

/**
 * __useUpsertActivityStatusMutation__
 *
 * To run a mutation, you first call `useUpsertActivityStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertActivityStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertActivityStatusMutation, { data, loading, error }] = useUpsertActivityStatusMutation({
 *   variables: {
 *      activityId: // value for 'activityId'
 *      checked: // value for 'checked'
 *   },
 * });
 */
export function useUpsertActivityStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpsertActivityStatusMutation, UpsertActivityStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertActivityStatusMutation, UpsertActivityStatusMutationVariables>(UpsertActivityStatusDocument, options);
      }
export type UpsertActivityStatusMutationHookResult = ReturnType<typeof useUpsertActivityStatusMutation>;
export type UpsertActivityStatusMutationResult = Apollo.MutationResult<UpsertActivityStatusMutation>;
export type UpsertActivityStatusMutationOptions = Apollo.BaseMutationOptions<UpsertActivityStatusMutation, UpsertActivityStatusMutationVariables>;
export const UpsertCourseProgressDocument = gql`
    mutation upsertCourseProgress($topicId: String!, $courseId: String!, $currentSlideId: String!, $status: AcademyCourseStatus!, $userId: Int!) {
  upsertCourseProgress(
    topicId: $topicId
    courseId: $courseId
    currentSlideId: $currentSlideId
    status: $status
    userId: $userId
  ) {
    userId
    topicId
    courseId
    currentSlideId
    status
  }
}
    `;
export type UpsertCourseProgressMutationFn = Apollo.MutationFunction<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>;

/**
 * __useUpsertCourseProgressMutation__
 *
 * To run a mutation, you first call `useUpsertCourseProgressMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertCourseProgressMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertCourseProgressMutation, { data, loading, error }] = useUpsertCourseProgressMutation({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      courseId: // value for 'courseId'
 *      currentSlideId: // value for 'currentSlideId'
 *      status: // value for 'status'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUpsertCourseProgressMutation(baseOptions?: Apollo.MutationHookOptions<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>(UpsertCourseProgressDocument, options);
      }
export type UpsertCourseProgressMutationHookResult = ReturnType<typeof useUpsertCourseProgressMutation>;
export type UpsertCourseProgressMutationResult = Apollo.MutationResult<UpsertCourseProgressMutation>;
export type UpsertCourseProgressMutationOptions = Apollo.BaseMutationOptions<UpsertCourseProgressMutation, UpsertCourseProgressMutationVariables>;
export const ResourceDocument = gql`
    query resource($resourceId: String, $courseId: String) {
  resource(resourceId: $resourceId, courseId: $courseId) {
    resourceId
    isBookmarked
    singleResourceContent {
      type
      ... on SingleCourseResource {
        courseId
        title
        preview
        completionTime
        embeddedAssets {
          id
          fileName
          description
          url
          contentType
        }
        progress {
          status
          currentSlideId
        }
        thumbnail {
          id
          description
          title
          url
        }
        tags
        ctas {
          id
          title
          url
        }
        slides {
          id
          type
          ... on ContentSlide {
            title
            content
          }
          ... on VideoSlide {
            title
            videoContent
            videoDetails {
              id
              wistiaId
            }
          }
          ... on TypeformSlide {
            title
            typeformId
            typeformUrl
          }
        }
      }
      ... on SingleArticleResource {
        title
        metaDescription
        tags
        header
        content
        embeddedAssets {
          id
          contentType
          fileName
          description
          url
        }
        thumbnail {
          id
          title
          description
          url
        }
        ctas {
          id
          title
          url
        }
      }
      ... on SingleTemplateResource {
        templateId
        title
        metaDescription
        tags
        header
        descriptionTitle
        description
        fileName
        content
        typeform {
          typeformId
          typeformUrl
        }
        ctas {
          id
          title
          url
        }
        thumbnail {
          id
          title
          description
          url
        }
        embeddedAssets {
          id
          contentType
          fileName
          description
          url
        }
        downloadableAsset {
          id
          fileName
          contentType
          url
        }
      }
    }
  }
}
    `;

/**
 * __useResourceQuery__
 *
 * To run a query within a React component, call `useResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourceQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *      courseId: // value for 'courseId'
 *   },
 * });
 */
export function useResourceQuery(baseOptions?: Apollo.QueryHookOptions<ResourceQuery, ResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourceQuery, ResourceQueryVariables>(ResourceDocument, options);
      }
export function useResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourceQuery, ResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourceQuery, ResourceQueryVariables>(ResourceDocument, options);
        }
export type ResourceQueryHookResult = ReturnType<typeof useResourceQuery>;
export type ResourceLazyQueryHookResult = ReturnType<typeof useResourceLazyQuery>;
export type ResourceQueryResult = Apollo.QueryResult<ResourceQuery, ResourceQueryVariables>;
export const ResourcesDocument = gql`
    query resources($featured: Boolean, $limit: Int, $popular: Boolean, $query: String, $sort: ResourceSortOptions, $resourceType: [ResourceType!], $bookmarked: Boolean, $status: [ResourceStatus!], $ids: [String!], $tags: [String!], $idsToExclude: [String!], $anonymousId: String, $createdAtGte: DateTime, $updatedAtGte: DateTime, $topics: [String!], $levels: [ResourceLevel!]) {
  resources(
    featured: $featured
    limit: $limit
    popular: $popular
    query: $query
    sort: $sort
    resourceType: $resourceType
    bookmarked: $bookmarked
    status: $status
    ids: $ids
    tags: $tags
    idsToExclude: $idsToExclude
    anonymousId: $anonymousId
    createdAtGte: $createdAtGte
    updatedAtGte: $updatedAtGte
    topics: $topics
    levels: $levels
  ) {
    nodes {
      bookmarked
      description
      featured
      gatedByPlan
      id
      nonprofitTopic
      popular
      thumbnailUrl
      tags
      topics
      levels
      title
      type
      createdAt
      updatedAt
      ... on Course {
        completionTime
        courseId
        status
      }
      ... on PartialLearningTrackResource {
        status
      }
    }
    totalCount
  }
}
    `;

/**
 * __useResourcesQuery__
 *
 * To run a query within a React component, call `useResourcesQuery` and pass it any options that fit your needs.
 * When your component renders, `useResourcesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResourcesQuery({
 *   variables: {
 *      featured: // value for 'featured'
 *      limit: // value for 'limit'
 *      popular: // value for 'popular'
 *      query: // value for 'query'
 *      sort: // value for 'sort'
 *      resourceType: // value for 'resourceType'
 *      bookmarked: // value for 'bookmarked'
 *      status: // value for 'status'
 *      ids: // value for 'ids'
 *      tags: // value for 'tags'
 *      idsToExclude: // value for 'idsToExclude'
 *      anonymousId: // value for 'anonymousId'
 *      createdAtGte: // value for 'createdAtGte'
 *      updatedAtGte: // value for 'updatedAtGte'
 *      topics: // value for 'topics'
 *      levels: // value for 'levels'
 *   },
 * });
 */
export function useResourcesQuery(baseOptions?: Apollo.QueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, options);
      }
export function useResourcesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResourcesQuery, ResourcesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResourcesQuery, ResourcesQueryVariables>(ResourcesDocument, options);
        }
export type ResourcesQueryHookResult = ReturnType<typeof useResourcesQuery>;
export type ResourcesLazyQueryHookResult = ReturnType<typeof useResourcesLazyQuery>;
export type ResourcesQueryResult = Apollo.QueryResult<ResourcesQuery, ResourcesQueryVariables>;
export const GetActivityStatusesDocument = gql`
    query getActivityStatuses {
  getActivityStatuses {
    activityId
    completedAt
    timeSinceCompletion
  }
}
    `;

/**
 * __useGetActivityStatusesQuery__
 *
 * To run a query within a React component, call `useGetActivityStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetActivityStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetActivityStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetActivityStatusesQuery(baseOptions?: Apollo.QueryHookOptions<GetActivityStatusesQuery, GetActivityStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetActivityStatusesQuery, GetActivityStatusesQueryVariables>(GetActivityStatusesDocument, options);
      }
export function useGetActivityStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetActivityStatusesQuery, GetActivityStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetActivityStatusesQuery, GetActivityStatusesQueryVariables>(GetActivityStatusesDocument, options);
        }
export type GetActivityStatusesQueryHookResult = ReturnType<typeof useGetActivityStatusesQuery>;
export type GetActivityStatusesLazyQueryHookResult = ReturnType<typeof useGetActivityStatusesLazyQuery>;
export type GetActivityStatusesQueryResult = Apollo.QueryResult<GetActivityStatusesQuery, GetActivityStatusesQueryVariables>;
export const CourseContentDocument = gql`
    query courseContent($resourceId: String!) {
  courseContent(resourceId: $resourceId) {
    courseId
    resourceId
    title
    preview
    slides {
      id
      type
      ... on ContentSlide {
        title
        content
      }
      ... on VideoSlide {
        title
        videoContent
        videoDetails {
          id
          wistiaId
        }
      }
      ... on TypeformSlide {
        title
        typeformUrl
        typeformId
      }
    }
  }
}
    `;

/**
 * __useCourseContentQuery__
 *
 * To run a query within a React component, call `useCourseContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseContentQuery({
 *   variables: {
 *      resourceId: // value for 'resourceId'
 *   },
 * });
 */
export function useCourseContentQuery(baseOptions: Apollo.QueryHookOptions<CourseContentQuery, CourseContentQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseContentQuery, CourseContentQueryVariables>(CourseContentDocument, options);
      }
export function useCourseContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseContentQuery, CourseContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseContentQuery, CourseContentQueryVariables>(CourseContentDocument, options);
        }
export type CourseContentQueryHookResult = ReturnType<typeof useCourseContentQuery>;
export type CourseContentLazyQueryHookResult = ReturnType<typeof useCourseContentLazyQuery>;
export type CourseContentQueryResult = Apollo.QueryResult<CourseContentQuery, CourseContentQueryVariables>;
export const CourseProgressDocument = gql`
    query courseProgress($topicId: String, $courseId: String!, $userId: Int!) {
  courseProgress(topicId: $topicId, courseId: $courseId, userId: $userId) {
    courseId
    topicId
    userId
    currentSlideId
    status
  }
}
    `;

/**
 * __useCourseProgressQuery__
 *
 * To run a query within a React component, call `useCourseProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useCourseProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCourseProgressQuery({
 *   variables: {
 *      topicId: // value for 'topicId'
 *      courseId: // value for 'courseId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useCourseProgressQuery(baseOptions: Apollo.QueryHookOptions<CourseProgressQuery, CourseProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CourseProgressQuery, CourseProgressQueryVariables>(CourseProgressDocument, options);
      }
export function useCourseProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CourseProgressQuery, CourseProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CourseProgressQuery, CourseProgressQueryVariables>(CourseProgressDocument, options);
        }
export type CourseProgressQueryHookResult = ReturnType<typeof useCourseProgressQuery>;
export type CourseProgressLazyQueryHookResult = ReturnType<typeof useCourseProgressLazyQuery>;
export type CourseProgressQueryResult = Apollo.QueryResult<CourseProgressQuery, CourseProgressQueryVariables>;
export const LearningTrackDocument = gql`
    query learningTrack($id: String!) {
  learningTrack(id: $id) {
    bookmarked
    id
    title
    description
    gatedByPlan
    trackType
    recommendedFor
    percentageCompleted
    thumbnailUrl
    skills
    status
    modules {
      id
      title
      description
      focusOn
      learn {
        bookmarked
        id
        gatedByPlan
        type
        title
        description
        status
        tags
        thumbnail {
          id
          title
          description
          url
        }
        url
      }
      takeAction {
        bookmarked
        id
        gatedByPlan
        type
        title
        description
        status
        tags
        thumbnail {
          id
          title
          description
          url
        }
        url
      }
      forACloserLook {
        bookmarked
        courseId
        id
        gatedByPlan
        type
        title
        description
        status
        tags
        thumbnail {
          id
          title
          description
          url
        }
        url
      }
    }
  }
}
    `;

/**
 * __useLearningTrackQuery__
 *
 * To run a query within a React component, call `useLearningTrackQuery` and pass it any options that fit your needs.
 * When your component renders, `useLearningTrackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useLearningTrackQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useLearningTrackQuery(baseOptions: Apollo.QueryHookOptions<LearningTrackQuery, LearningTrackQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<LearningTrackQuery, LearningTrackQueryVariables>(LearningTrackDocument, options);
      }
export function useLearningTrackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<LearningTrackQuery, LearningTrackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<LearningTrackQuery, LearningTrackQueryVariables>(LearningTrackDocument, options);
        }
export type LearningTrackQueryHookResult = ReturnType<typeof useLearningTrackQuery>;
export type LearningTrackLazyQueryHookResult = ReturnType<typeof useLearningTrackLazyQuery>;
export type LearningTrackQueryResult = Apollo.QueryResult<LearningTrackQuery, LearningTrackQueryVariables>;
export const UserToSavedAcademyResourceDocument = gql`
    query UserToSavedAcademyResource($userId: Int!) {
  UserToSavedAcademyResource(userId: $userId) {
    userId
    academyResourceId
  }
}
    `;

/**
 * __useUserToSavedAcademyResourceQuery__
 *
 * To run a query within a React component, call `useUserToSavedAcademyResourceQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserToSavedAcademyResourceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserToSavedAcademyResourceQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserToSavedAcademyResourceQuery(baseOptions: Apollo.QueryHookOptions<UserToSavedAcademyResourceQuery, UserToSavedAcademyResourceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserToSavedAcademyResourceQuery, UserToSavedAcademyResourceQueryVariables>(UserToSavedAcademyResourceDocument, options);
      }
export function useUserToSavedAcademyResourceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserToSavedAcademyResourceQuery, UserToSavedAcademyResourceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserToSavedAcademyResourceQuery, UserToSavedAcademyResourceQueryVariables>(UserToSavedAcademyResourceDocument, options);
        }
export type UserToSavedAcademyResourceQueryHookResult = ReturnType<typeof useUserToSavedAcademyResourceQuery>;
export type UserToSavedAcademyResourceLazyQueryHookResult = ReturnType<typeof useUserToSavedAcademyResourceLazyQuery>;
export type UserToSavedAcademyResourceQueryResult = Apollo.QueryResult<UserToSavedAcademyResourceQuery, UserToSavedAcademyResourceQueryVariables>;